import styled from 'styled-components';

export const LeftTodo = styled.p`
font-size: 1.4rem;
font-weight: bold;
color: #ffab73;
`